<div style="position: absolute; top: 30%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column;">
  <div style="display: flex;">
    <img src="../../assets/images/logos/theme2.png" alt="Fleetmaid" loading="eager" fetchpriority="high" style="max-height: 3.5em; -webkit-filter: invert(100%);
                          filter: invert(100%);">
    <div class="spinner-grow" role="status" style="width: 3em !important; height: 3em !important">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <span style="margin-left: 1em;">Redirecting..</span>
</div>